// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-simple-screen',
    // #endregion
    // #region Mixins
    mixins: [appHost.mixins.culture],
    // #endregion
    // #region Computed
    computed: {
        hasImage() {
            return !utils.isNullOrEmpty(appHost.config.loginPageImage) && (appHost.pageMeta.options?.showImage ?? true);
        },
        getImageStyles() {
            return {
                'background-image': `url(${appHost.config.loginPageImage?.replace('./', '/')})`
            };
        },
        footerMenuEntriesRight() {
            return this.$appHost.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    }
    // #endregion
});
// #endregion
